import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { TvStatus } from "../../Tv";
export const TvLabel = ()=>{
    return /*#__PURE__*/ _jsxs("section", {
        children: [
            /*#__PURE__*/ _jsx("h3", {
                className: "uppercase text-white text-sm font-bold mb-4 lg:text-base",
                children: "Parks channel tv"
            }),
            /*#__PURE__*/ _jsx(TvStatus, {})
        ]
    });
};
